export type ConfidenceLevel = 'high' | 'medium' | 'low';

/**
 * The level a "Data Confidence: MEDIUM (reason)" value opens with, and the reason after it.
 * Only the opening word sets the level: a reason may say "high-volume building" beside a LOW.
 * Null when the value does not open with a level, so callers keep their own handling.
 */
export const parseConfidenceValue = (value: string): { level: ConfidenceLevel; reason: string } | null => {
  // "MEDIUM (…)" or "Medium confidence — …": the word "confidence" belongs to the level, not the reason.
  const match = /^[\s*_]*(high|medium|moderate|low)\b(?:\s+confidence\b)?[\s*_]*/i.exec(value);
  if (!match) return null;
  const word = match[1]!.toLowerCase();
  const reason = value
    .slice(match[0].length)
    .replace(/^[\s:;,.–—-]+/, '')
    .trim();
  return {
    level: word === 'moderate' ? 'medium' : (word as ConfidenceLevel),
    reason: (/^\((.*)\)$/s.exec(reason)?.[1] ?? reason).trim(),
  };
};
